import { Box, Flex, Image } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { COMMON_WEB_PATH } from '../../constant';
import useCheckLogin from '../../hook/useCheckLogin';
import Balance from '../Balance/Balance';
import BetRecordButton from '../BetRecordButton/BetRecordButton';
import ClearCashRegisterButton from '../ClearCash/ClearCashRegisterButton';
import LngButton from './HeaderComponents/LngButton';
import LoginButton from './HeaderComponents/LoginButton';
import MusicToggleButton from './HeaderComponents/MusicToggleButton';
import ReloadButton from './HeaderComponents/ReloadButton';
import UidBanner from './HeaderComponents/UidBanner';
import UserButton from './HeaderComponents/UserButton';

const HeaderBottom = () => {
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const memberInfo = useSelector((state) => state.isMemberInfo);

  return (
    <Box
      width={{
        base: `100%`,
        xl: `100%`
      }}
      minHeight={{
        base: '65px',
        sm: '70px',
        md: '100px',
        xl: '125px'
      }}
      pt={'5px'}
      position="fixed"
      mx="auto"
      bottom="0px"
      _before={{
        base: {
          content: "''",
          position: 'absolute',
          bottom: 0,
          left: 0,
          bgSize: '100%100%',
          bgRepeat: 'no-repeat',
          bgPosition: 'center',
          bgImage: `url(${COMMON_WEB_PATH}/blue-layout/header/header_background.png)`,
          transform: 'scaleY(-1)',
          w: '100%',
          h: '100%'
        }
      }}
      _after={{
        base: {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          bgSize: '100%100%',
          bgRepeat: 'no-repeat',
          bgPosition: 'center',
          // bgImage: `url(${COMMON_WEB_PATH}/blue-layout/header/header_logo_banner.png)`,
          w: {
            base: '30%',
            xl: '25%'
          },
          h: '100%',
          pointerEvents: 'none'
        }
      }}
      bgSize="102% 106%"
      zIndex={{
        base: '999',
        sm: '1001'
      }}
      display="flex"
      pb={{
        base: '0px',
        lg: '10px'
      }}
      alignItems={'flex-end'}
      justifyContent="space-between"
      transition="all 0.3s ease" // 過渡
      pr={{
        base: '1em',
        md: 'unset'
      }}
    >
      <Flex
        alignItems={'center'}
        justifyContent={'space-between'}
        width="100%"
        height="100%"
      >
        {/* <Flex
          alignItems={'center'}
          justifyContent={'center'}
          w={{
            base: '30%',
            xl: '25%'
          }}
          zIndex={1}
        >
          <Image
            src={`${COMMON_WEB_PATH}/blue-layout/logo_192.png`}
            alt="Logo"
            objectFit="cover"
            width="100%"
            maxW={{
              base: '85px',
              md: '105px'
            }}
            height="100%"
          />
        </Flex> */}

        <Flex
          flex={1}
          gap={{
            base: '5px',
            md: '30px'
          }}
          mr={{
            base: 0,
            md: '5%'
          }}
          justifyContent={'flex-end'}
        >
          <Flex gap="25px" alignItems={'center'}>
            {/* 餘額 */}
            {isLogin ? (
              <Flex gap="5px" alignItems={'center'}>
                <Balance />
              </Flex>
            ) : null}
            {isMachineUser || isMachineDomain ? (
              <Flex gap="10px">
                {/* 棄分按鈕 */}
                <ClearCashRegisterButton />
                {/* 投注記錄 */}
                <BetRecordButton />
              </Flex>
            ) : null}
          </Flex>
          {isMachineUser || isMachineDomain ? <UidBanner /> : null}
          <Flex
            gap={{
              base: '5px',
              md: '10px'
            }}
          >
            <Box
              display={{
                base: 'none',
                md: 'flex'
              }}
              alignItems={'center'}
            >
              <LngButton />
            </Box>
            {/* 重整按鈕 */}{' '}
            <Box
              display={{
                base: 'none',
                md: 'flex'
              }}
              alignItems={'center'}
            >
              <ReloadButton />{' '}
            </Box>
            {/* 音樂按鈕 */}
            <MusicToggleButton />
            {isLogin ? (
              isMachineDomain || isMachineUser ? null : (
                <UserButton />
              )
            ) : (
              <LoginButton />
            )}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default HeaderBottom;
